import React from "react";

const OurTeam = () => {
  return (
    <div>
      <section
        className="page-title-section overlay"
        style={{ backgroundImage: "url(images/backgrounds/page-title.jpg)" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-8">
              <ul className="list-inline custom-breadcrumb mb-2">
                <li className="list-inline-item text-white h3 font-secondary">
                  Fees & Payment
                </li>
              </ul>
              <p className="text-lighten mb-0">
                Transparent pricing for our services. Appointments are confirmed
                only after payment.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-sm-6 mb-5">
              <div className="card border-0 rounded-0 hover-shadow">
                <div className="card-body">
                  <h4 className="card-title">Initial Assessment</h4>
                  <p className="mb-0">
                    <i className="ti ti-clipboard text-primary mr-2"></i>
                    PKR 2,500
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6 mb-5">
              <div className="card border-0 rounded-0 hover-shadow">
                <div className="card-body">
                  <h4 className="card-title">Follow-Up Session</h4>
                  <p className="mb-0">
                    <i className="ti ti-clipboard text-primary mr-2"></i>
                    PKR 2,000
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6 mb-5">
              <div className="card border-0 rounded-0 hover-shadow">
                <div className="card-body">
                  <h4 className="card-title">💳 Payment Method</h4>
                  <p className="mb-0">
                    <i className="ti ti-credit-card text-primary mr-2"></i>
                    EasyPaisa (advance payment required)
                  </p>
                  <p className="text-muted small mt-2 mb-0">
                    Appointments are confirmed only after payment.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default OurTeam;
